var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-text application-heading"},[_vm._v(" What are verified events? "),[_c('PulseAndRiskDefinitions',{attrs:{"initial":'VERIFIED_EVENTS',"new-icon":false}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }